import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { Container, Row, Col, Button } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "react-bootstrap";

import { useSelector } from "react-redux";
import { getFAQs, UpdateStatusFAQs } from "../../../stores/services/knowledgebase.service";
import AddFAQs from "./AddFAQs";
import EditFAQs from "./EditFAQs";
import ViewFAQs from "./ViewFAQs";

const FAQS = () => {
    const [addModalFlag, setAddModalFlag] = useState<boolean>(false)
    const [editModalFlag, setEditModalFlag] = useState<boolean>(false)
    const [viewModalFlag, setViewModalFlag] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [refreshData, setRefreshData] = useState<boolean>(false)
    const [allFAQsData, setAllFAQsData] = useState<any>([])
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const itemsPerPage = 10
    const [itemsToShow, setItemsToShow] = useState(10);

    useEffect(() => {
        const getAllData = async () => {
            setLoading(true)
            try {
                let res = await getFAQs(email, amc_code)
                if (res.status === 200 && res.data.status === 200) {
                    setAllFAQsData(res?.data?.data)
                }
            }
            catch (error) {
                toast.error("No Data Found!")
            }
            finally {
                setLoading(false)
            }
        }
        getAllData()
    }, [refreshData])

    const handleShowMore = () => {
        setItemsToShow(prev => prev + itemsPerPage);
    };

    const changeStatus = async (item) => {
        setLoading(true)
        let status;
        if (item?.status == true) {
            status = "false"
        }
        else {
            status = "true"
        }
        try {
            let res = await UpdateStatusFAQs(
                email,
                amc_code,
                item?._id || "",
                status
            )
            if (res.status === 200 && res.data.status === 200) {
                toast.success(res.data.message)
                setRefreshData(!refreshData)
            }
        }
        catch (error) {
            toast.error("Error Updating Status")
        }
        finally {
            setLoading(false)
        }
    }

    const renderTable = () => {
        return allFAQsData?.slice(0, itemsToShow)?.map((item: any, index: any) => {
            return (
                <tr key={index}>
                    <td data-toggle="tooltip" data-placement="top" title={item?.question}>
                        {item.question?.slice(
                            0,
                            150
                        )}{" "}
                        {item.question.length >
                            150 && "..."}
                    </td>
                    <td data-toggle="tooltip" data-placement="top" title={item?.answer}>
                        {item.answer?.slice(
                            0,
                            550
                        )}{" "}
                        {item.answer.length >
                            550 && "..."}
                    </td>
                    <td className=" ">
                        <div className="multi-icons pointer">
                            <button
                                type="button"
                                className="btn-icon btn-link like btn btn-primary btn-sm"
                                onClick={() => {
                                    sessionStorage.setItem("FAQsObj", JSON.stringify(item));
                                    setViewModalFlag(true)
                                }}
                            >
                                <i className="fas fa-eye"></i>
                            </button>

                            <button
                                type="button"
                                className="btn-icon btn-link like btn btn-info btn-sm"
                                onClick={() => {
                                    sessionStorage.setItem("FAQsObj", JSON.stringify(item));
                                    setEditModalFlag(true)
                                }}
                            >
                                <i className="tim-icons icon-pencil"></i>
                            </button>
                            {item?.status != true ? (
                                <button
                                    type="button"
                                    className="btn-icon btn-link like btn btn-danger btn-sm"
                                    onClick={() => {
                                        changeStatus(item)
                                    }}
                                >
                                    <i className="tim-icons icon-simple-remove"></i>
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="btn-icon btn-link like btn btn-success btn-sm"
                                    onClick={() => {
                                        changeStatus(item)
                                    }}
                                >
                                    <i className="fas fa-check"></i>
                                </button>
                            )}
                        </div>
                    </td>
                </tr>
            );
        });
    }

    return (
        <div className="content">
            <ToastContainer />
            {/* ---------------- Add Modal ------------ */}
            <Modal
                className=""
                dialogClassName="modal90w"
                show={addModalFlag ? true : false}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setAddModalFlag(false);
                }}
                centered={true}
            >
                <div className="modal-header ">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setAddModalFlag(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h6 className="title title-up">Add FAQ</h6>
                </div>
                <div className="modal-body">
                    <AddFAQs
                        refreshData={refreshData}
                        setRefreshData={setRefreshData}
                        setAddModalFlag={setAddModalFlag}
                    />
                </div>
            </Modal>

            {/* ---------------- Edit Modal ------------ */}
            <Modal
                className=""
                dialogClassName="modal90w"
                show={editModalFlag ? true : false}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setEditModalFlag(false);
                }}
                centered={true}
            >
                <div className="modal-header ">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setEditModalFlag(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h6 className="title title-up">Edit FAQ</h6>
                </div>
                <div className="modal-body">
                    <EditFAQs
                        refreshData={refreshData}
                        setRefreshData={setRefreshData}
                        setEditModalFlag={setEditModalFlag}
                    />
                </div>
            </Modal>

            {/* ---------------- View Modal ------------ */}
            <Modal
                className=""
                dialogClassName="modal90w"
                show={viewModalFlag ? true : false}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setViewModalFlag(false);
                }}
                centered={true}
            >
                <div className="modal-header ">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setViewModalFlag(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h6 className="title title-up">View FAQ</h6>
                </div>
                <div className="modal-body">
                    <ViewFAQs
                        setViewModalFlag={setViewModalFlag}
                    />
                </div>
            </Modal>

            <Row>
                <Col md="12">
                    <Container fluid>
                        <ToastContainer limit={1} />
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">
                                    FAQs Listing
                                    <button
                                        className="btn btn-primary btn-sm float-right"
                                        onClick={() => {
                                            setAddModalFlag(true)
                                        }}
                                    >
                                        <i className="fa fa-plus mr-2"></i> Add New
                                    </button>
                                </h4>
                            </div>
                            {!loading ? (
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table mt-3 ">
                                            <thead>
                                                <th
                                                    style={{
                                                        paddingLeft: "7px",
                                                        paddingRight: "7px",
                                                    }}
                                                >
                                                    Questions
                                                </th>
                                                <th
                                                    style={{
                                                        paddingLeft: "7px",
                                                        paddingRight: "7px",
                                                    }}
                                                >
                                                    Answers
                                                </th>
                                                <th
                                                    style={{
                                                        paddingLeft: "11px",
                                                        paddingRight: "11px",
                                                    }}
                                                >
                                                    Actions
                                                </th>

                                            </thead>
                                            <tbody>{renderTable()}</tbody>
                                        </table>

                                    </div>
                                </div>
                            ) : (
                                <div className="d-flex justify-content-center">
                                    <div
                                        className="fa fa-spinner fa-spin fa-3x mt-5 mb-5"
                                        role="status"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            )}
                            {itemsToShow < allFAQsData?.length && (
                                <div
                                    className='d-flex justify-content-center my-2'
                                >
                                    <button
                                        className="btn btn-primary mt-3"
                                        onClick={handleShowMore}
                                    >
                                        Show More
                                    </button>
                                </div>
                            )}
                        </div>
                    </Container>
                </Col>
            </Row>
        </div>
    );
};

export default FAQS;
